import { Fieldset, Grid, NumberInput, Space, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import {
	IconArrowDown,
	IconArrowUp,
	IconBasketDollar,
	IconShoppingCartCheck,
	IconTextCaption,
} from '@tabler/icons-react';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';

type UpsertProductPriceFormProps = {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>;
};

export function UpsertProductPriceForm({ form }: UpsertProductPriceFormProps) {
	return (
		<>
			<Fieldset legend={'Information'}>
				<Grid>
					<Grid.Col span={6}>
						<TextInput
							label={'SKUID'}
							leftSection={<IconTextCaption {...defaultIconStyle} />}
							key={form.key('skuid')}
							{...form.getInputProps('skuid')}
							disabled
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<TextInput
							label={'Branch Name'}
							leftSection={<IconTextCaption {...defaultIconStyle} />}
							key={form.key('branchName')}
							{...form.getInputProps('branchName')}
							disabled
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
			<Space h={20} />
			<Fieldset legend={'Price'}>
				<Grid>
					<Grid.Col span={12}>
						<NumberInput
							label={'Price inc. VAT'}
							placeholder={'Insert price including VAT of product...'}
							key={form.key('incVatPrice')}
							{...form.getInputProps('incVatPrice')}
							decimalScale={2}
							prefix="£"
							leftSection={<IconBasketDollar {...defaultIconStyle} />}
							allowNegative={false}
							thousandSeparator={','}
						/>
					</Grid.Col>
					<Grid.Col span={12}>
						<TextInput
							label={'Stock Level'}
							placeholder={'Insert stock level of product...'}
							leftSection={<IconShoppingCartCheck {...defaultIconStyle} />}
							key={form.key('stockLevel')}
							{...form.getInputProps('stockLevel')}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							label={'Minimum Stock'}
							placeholder={'Insert minimum stock...'}
							key={form.key('minStock')}
							{...form.getInputProps('minStock')}
							leftSection={<IconArrowDown {...defaultIconStyle} />}
							allowDecimal={false}
							thousandSeparator={','}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							label={'Maximum Stock'}
							placeholder={'Insert maximum stock...'}
							key={form.key('maxStock')}
							{...form.getInputProps('maxStock')}
							leftSection={<IconArrowUp {...defaultIconStyle} />}
							allowDecimal={false}
							thousandSeparator={','}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}
